import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import SiteSummary from "../SiteSummary.tsx";
import LoginModal from "../LoginModal.tsx";
import { useAppSelector } from "../../../../services/hooks.ts";
import { useTranslation } from "react-i18next";
import { useStore } from "react-redux";
import { RootState } from "../../../../stores/shopStore.ts";

export default function SiteSummaryCart() {
    const navigate = useNavigate();
    const store = useStore<RootState>();
    const [loginModal, setLoginModal] = useState(false);
    const loadingQuantity = useAppSelector((state) => state.cart.loading)
    const cart = useAppSelector((state) => state.cart.products)
    const { t } = useTranslation('cart');
    const [disabled, setDisabled] = useState(false)
    //const logged = useAppSelector((state) => state.user.logged)
    // const disabled = () => {
    //     return (loadingQuantity || cart.length === 0)
    // };

    const handleCartButton = async () => {
        const user = store.getState().user;
        
        //if (!user.loaded) return;
        if (user.logged) {
            console.log('handlecartButton')
            await navigate('/cart/checkout')
            return;
        }

        setLoginModal(true);
    };

    const onSuccessLogin = () => {
        setLoginModal(false);
        handleCartButton().then();
    };

    useEffect(() => {
        setDisabled(loadingQuantity || cart.length === 0)
    }, [loadingQuantity, cart])

    return (
        <SiteSummary>
            <SiteSummary.Button
                disabled={disabled}
                onClick={handleCartButton}
            >
                {/*
                <div className={"text-white fs-5"}>
                    <strong>{t('cart.next_step')}</strong>
                </div>
                */}{t('cart.next_step')}
            </SiteSummary.Button>

            <SiteSummary.Footer>
                <LoginModal success={onSuccessLogin} show={loginModal} setShow={setLoginModal} />
            </SiteSummary.Footer>
        </SiteSummary>
    );
}